import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
